export const VIN_PREFIXES = ['X0T', 'LFW', 'ECB', 'BP', 'PT', 'SPM', 'BS'] as const;
export type VinPrefix = (typeof VIN_PREFIXES)[number];

export const TAIL_MAX_LENGTH = 15;
/** Символы, запрещённые в хвосте VIN (убираем I, O, Q и всё нелатинское/нецифровое) */
export const TAIL_ALLOWED = /[^A-HJ-NPR-Z0-9]/g;

export const CYRILLIC_TO_LATIN: Record<string, string> = {
  А: 'A', В: 'B', Е: 'E', К: 'K', М: 'M',
  Н: 'H', О: 'O', Р: 'P', С: 'C', Т: 'T',
  У: 'Y', Х: 'X',
};

/** Заменяет кириллические омоглифы латинскими эквивалентами (А→A, О→O и т.д.) */
export function transliterate(input: string): string {
  return input.replace(/[А-Я]/g, (ch) => CYRILLIC_TO_LATIN[ch] ?? '');
}

/** Очищает хвост VIN: транслитерация + удаление запрещённых символов + обрезка */
export function cleanTail(raw: string): string {
  return transliterate(raw.toUpperCase())
    .replace(TAIL_ALLOWED, '')
    .slice(0, TAIL_MAX_LENGTH);
}
